export enum ErrorCodes {
  InternalError = 500,
  success = 200,
  UnAuthorized = 401,
}

export enum ErrorTypes {
  Unhandled = "unhandled",
  Validation = "validation",
}

export enum ReconciliationStatus {
  PENDING = "Pending",
  RECONCILED = "Reconciled",
  INVOICEGENERATED = "Invoice Generated",
}

export enum UserType {
  CUSTOMER = "Customer",
}

export enum BillingType {
  GROUP = "Group",
  INDIVIDUAL = "Individual",
}

export enum BillingPlan {
  PayPerStay = "PPS",
  FlatFee = "Flat Fee",
  RollUp = "RollUp",
}

export enum BenchMarkErrorType {
  INVALID_FILTER = "Invalid Filter",
  NOT_ENOUGH_PEER = "Not Enough Peer",
}

export enum BenchmarkScreenType {
  CHANNEL_BENCHMARK = "CHANNEL_BENCHMARK",
  MMA = "MMA",
  MEI = "MEI",
}
